import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '@/components/layout/Footer';
import { AnimatePresence, motion } from 'framer-motion';

export default function LandingLayout() {
    return (
        <AnimatePresence mode="wait">
            <motion.div
                key="landing-layout"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="flex flex-col min-h-screen bg-neutral-950"
            >
                <main className="flex-1">
                    <Outlet />
                </main>

                <Footer />
            </motion.div>
        </AnimatePresence>
    );
}
